import { ExamScopePage } from "./ExamScopePage";
export default ExamScopePage;
